{
  "name": "demf-flows-list",
  "version": "4.1.1",
  "private": false,
  "type": "module",
  "engines": {
    "node": ">=22.0.0 <23 || >=24.8.0 <25"
  },
  "scripts": {
    "predev": "node ./scripts/generate-vuetify-locales.mjs",
    "dev": "concurrently \"vite build --watch --mode development\" \"vite preview --port 9010\"",
    "prebuild": "node ./scripts/generate-vuetify-locales.mjs",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint . --fix",
    "format": "prettier --write src/"
  },
  "dependencies": {
    "@mdi/font": "^7.4.47",
    "axios": "^1.16.0",
    "single-spa-vue": "^3.0.1",
    "vue": "^3.5.34",
    "vue-i18n": "^11.4.0",
    "vue-router": "^5.0.6",
    "vuetify": "^3.12.5",
    "pinia": "^3.0.4"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@vitejs/plugin-vue": "^6.0.6",
    "@vue/eslint-config-prettier": "^10.2.0",
    "concurrently": "^9.2.1",
    "eslint": "^10.3.0",
    "eslint-plugin-vue": "^10.9.1",
    "globals": "^17.6.0",
    "prettier": "^3.8.3",
    "vite": "^8.0.10",
    "vite-plugin-vue-devtools": "^8.1.1",
    "vite-plugin-css-injected-by-js": "^5.0.1"
  }
}
